import React, { Component } from 'react';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import { Tabs } from './tabs';
import { IntegerStep } from './integerStep';
import { Custom } from './custom';
import { Options } from './options';

import {
  // isMobileTablet,
} from '../../../library/calc';

import { autoClickPreferences } from '../../../library/constants';

class PreferencesDesktop extends Component {

  state = {
    activeTab: ( autoClickPreferences ?  'options': 'tree'),
    // activeTab: 'custom',
  }

  setActiveTab(tab){
    this.setState({
      activeTab: tab,
    })
  }

  componentDidMount(){
  }

  onSubmit(){

    if ( this.state.activeTab === 'tree'  ){
      this.refs.integerSteps.onSubmit();
    }
    else {
      this.refs.customColor.onSubmit();
    }

  }

  showTabContent(){

    const tabObjContent = {
      'tree':  <IntegerStep
                      ref="integerSteps"
                      translatedLabels={this.props.translatedLabels}
                      fetchPreferences={this.props.fetchPreferences}
                      chartType={this.props.chartType}
                      postPreferences={this.props.postPreferences}
                      preferences={this.props.preferences}
                      hideModal={this.props.hideModal}
                      isPedigree={this.props.isPedigree}
                />,
      'custom':
                    <Custom
                      id="customColor"
                      ref="customColor"
                      hideModal={this.props.hideModal}
                      nodeObjs={this.props.nodeObjs}
                      setCustomColors={this.props.setCustomColors}
                      setCustomStylesForTree={this.props.setCustomStylesForTree}
                      resetToDefaultColors={this.props.resetToDefaultColors}
                      postPreferences={this.props.postPreferences}
                      fontSizeChoice={this.props.fontSizeChoice}
                      selectedtheme={this.props.selectedtheme}
                      maleCustomColor={this.props.maleCustomColor}
                      femaleCustomColor={this.props.femaleCustomColor}
                      unGenderedCustomColor={this.props.unGenderedCustomColor}
                      presetCustomObj={this.props.presetCustomObj}
                      stageBackgroundCustomColor={this.props.stageBackgroundCustomColor}
                      placeholderImage_m={this.props.placeholderImage_m}
                      placeholderImage_f={this.props.placeholderImage_f}
                      placeholderImage_u={this.props.placeholderImage_u}
                    />,
      'options':
                    <Options
                      setOptionsForTree={this.props.setOptionsForTree}
                      postPreferences={this.props.postPreferences}
                      presetCustomObj={this.props.presetCustomObj}
                      showCardPhotos={this.props.showCardPhotos}
                      showCardEditIcon={this.props.showCardEditIcon}
                      showCardEmailInvite={this.props.showCardEmailInvite}
                      preferences={this.props.preferences}
                      id="optionsTab"
                      ref="optionsTab"
                    />,
    }

    return tabObjContent[this.state.activeTab];

  }

  render() {
    let style = {
      top: '12vh',
    };

    return (
        <Modal
          className="preferencesDesktopModalClass"
          style={style}
          width={800}
          height={300}
          title={this.props.translatedLabels['Tree Preferences'].translatedLabel}
          visible={this.props.modalOpen}
          onSubmit={this.handleOk}
          onCancel={()=>{this.props.hideModal();}}
          footer={[
            <Button key="Cancel" onClick={this.props.hideModal}>{this.props.translatedLabels['Cancel'].translatedLabel}</Button>,
            <Button key="submit" type="primary" onClick={this.onSubmit.bind(this)}>
              {this.props.translatedLabels['Submit'].translatedLabel}
            </Button>,
          ]}
        >
          <div
            style={{
              height: '28px'
            }}
          >
            <Tabs
              setActiveTab={this.setActiveTab.bind(this)}
              activeTab={this.state.activeTab}
              chartType={this.props.chartType}
            />
          </div>
          <div>
              {
                  this.showTabContent()
              }
          </div>
        </Modal>
    )
  }

}


export default PreferencesDesktop;
